import dayjs from 'dayjs'

// The API stores and returns timestamps as plain "YYYY-MM-DD HH:mm:ss" strings in UTC (the Laravel
// app timezone); ISO strings with an offset or Z are already unambiguous.
const SERVER_TZ = 'UTC'
const HAS_OFFSET = /([zZ]|[+-]\d{2}:?\d{2})$/

// A dayjs in the user's timezone (their chosen one, else the browser's), or null for no value
export function toUserTz(val, userTz) {
    if (!val) return null
    const tz = userTz || dayjs.tz.guess()
    const text = String(val)
    return (HAS_OFFSET.test(text) ? dayjs(text) : dayjs.tz(text, SERVER_TZ)).tz(tz)
}

// Mixin for components that show server timestamps in the user's timezone
export default {
    computed: {
        userTz() {
            // GGB users have no saved timezone: the browser's
            return dayjs.tz.guess()
        },
    },
    methods: {
        formatDate(val) {
            const d = toUserTz(val, this.userTz)
            return d ? d.format('D MMM YYYY') : '—'
        },
        formatTime(val, withSeconds) {
            const d = toUserTz(val, this.userTz)
            return d ? d.format(withSeconds ? 'h:mm:ss A' : 'h:mm A') : ''
        },
    },
}
